// extracted by mini-css-extract-plugin
export default {"banner-container":"Banner_banner-container__l2gzW","show-prompt":"Banner_show-prompt__zGmK-"};